import {
  FETCH_REGIONS_REQUEST,
  FETCH_REGIONS_SUCCESS,
  FETCH_BANKS_REQUEST,
  FETCH_BANKS_SUCCESS,
  FETCH_COMMUNES_REQUEST,
  FETCH_COMMUNES_SUCCESS,
  FETCH_CITYS_REQUEST,
  FETCH_CITYS_SUCCESS,
  ACTIVE_STEP,
  DEACTIVATE_STEP
} from '../constants/utils'
import {
  reqGetRegions,
  reqGetCommunes,
  reqGetBanks,
  reqGetCitys
} from '../../utils/httpRequests/utils'
export function getRegions (token) {
  return (dispatch) => {
    dispatch({
      type: FETCH_REGIONS_REQUEST
    })
    reqGetRegions(token)
      .then(response => {
        dispatch({
          type: FETCH_REGIONS_SUCCESS,
          payload: response.data
        })
      })
  }
}

export function getCommunes (token, regionId) {
  return (dispatch) => {
    dispatch({
      type: FETCH_COMMUNES_REQUEST
    })
    reqGetCommunes(token, regionId)
      .then(response => {
        dispatch({
          type: FETCH_COMMUNES_SUCCESS,
          payload: response.data
        })
      })
  }
} 

export function getBanks (token) {
  return (dispatch) => {
    dispatch({
      type: FETCH_BANKS_REQUEST
    })
    reqGetBanks(token)
      .then(response => {
        dispatch({
          type: FETCH_BANKS_SUCCESS,
          payload: response.data
        })
      })
  }
}

export function getCitys (token, regionId) {
  return (dispatch) => {
    dispatch({
      type: FETCH_CITYS_REQUEST
    })
    reqGetCitys(token, regionId)
    .then(response => {
      // console.log('Response getCitys', response);
      dispatch({
        type: FETCH_CITYS_SUCCESS,
        payload: response.data
      })
    })
  }
}

export function activeStep () {
  // console.log('Entre al activeStep');
  return {
    type: ACTIVE_STEP
  }
}

export function deactivateStep () {
  // console.log('Entre al deactivateStep');
  return {
    type: DEACTIVATE_STEP
  }
}
